// Preset designs for ChocoSnaps & Choco Digits customizer.
// Each preset is a small inline SVG data-url so they render instantly with no extra network.

const svgDataUrl = (svg) =>
  `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;

const star = (color = '#FFB020') => svgDataUrl(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
  <defs><radialGradient id='g' cx='50%' cy='50%' r='65%'><stop offset='0' stop-color='${color}' stop-opacity='1'/><stop offset='1' stop-color='${color}' stop-opacity='0.85'/></radialGradient></defs>
  <rect width='200' height='200' fill='white' rx='28'/>
  <g stroke='#1B1B1F' stroke-width='6' stroke-linejoin='round'>
    <polygon points='100,15 122,75 188,80 138,118 156,182 100,148 44,182 62,118 12,80 78,75' fill='url(#g)'/>
  </g>
</svg>`);

const heart = (color = '#FF3EA5') => svgDataUrl(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
  <rect width='200' height='200' fill='white' rx='28'/>
  <path d='M100 175 L25 100 a40 40 0 1 1 75 -32 a40 40 0 1 1 75 32 Z' fill='${color}' stroke='#1B1B1F' stroke-width='6' stroke-linejoin='round'/>
</svg>`);

const smiley = () => svgDataUrl(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
  <rect width='200' height='200' fill='white' rx='28'/>
  <circle cx='100' cy='100' r='75' fill='#FFB020' stroke='#1B1B1F' stroke-width='6'/>
  <circle cx='75' cy='85' r='10' fill='#1B1B1F'/>
  <circle cx='125' cy='85' r='10' fill='#1B1B1F'/>
  <path d='M65 120 Q100 160 135 120' stroke='#1B1B1F' stroke-width='8' fill='none' stroke-linecap='round'/>
</svg>`);

const cake = () => svgDataUrl(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
  <rect width='200' height='200' fill='white' rx='28'/>
  <rect x='40' y='100' width='120' height='60' rx='10' fill='#FF3EA5' stroke='#1B1B1F' stroke-width='6'/>
  <path d='M40 110 Q70 140 100 110 Q130 140 160 110' fill='none' stroke='#FFF6EC' stroke-width='6'/>
  <rect x='90' y='60' width='20' height='40' fill='#FFB020' stroke='#1B1B1F' stroke-width='4'/>
  <path d='M100 50 Q92 38 100 30 Q108 38 100 50' fill='#FF3EA5' stroke='#1B1B1F' stroke-width='3'/>
</svg>`);

const paw = () => svgDataUrl(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
  <rect width='200' height='200' fill='white' rx='28'/>
  <g fill='#4A2A1A' stroke='#1B1B1F' stroke-width='5'>
    <ellipse cx='100' cy='130' rx='40' ry='34'/>
    <ellipse cx='55' cy='90' rx='18' ry='22'/>
    <ellipse cx='145' cy='90' rx='18' ry='22'/>
    <ellipse cx='80' cy='55' rx='14' ry='18'/>
    <ellipse cx='120' cy='55' rx='14' ry='18'/>
  </g>
</svg>`);

const dino = () => svgDataUrl(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
  <rect width='200' height='200' fill='white' rx='28'/>
  <path d='M40 140 Q40 80 90 80 Q90 50 130 60 Q160 70 160 110 Q170 110 170 130 Q170 150 150 150 L140 170 L130 150 L80 150 L70 170 L60 150 L50 150 Q40 150 40 140 Z' fill='#1FBF7A' stroke='#1B1B1F' stroke-width='5'/>
  <circle cx='130' cy='85' r='5' fill='#1B1B1F'/>
</svg>`);

const rainbow = () => svgDataUrl(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
  <rect width='200' height='200' fill='#D9F2FF' rx='28'/>
  <path d='M20 140 A80 80 0 0 1 180 140' fill='none' stroke='#E5484D' stroke-width='14'/>
  <path d='M35 140 A65 65 0 0 1 165 140' fill='none' stroke='#FFB020' stroke-width='14'/>
  <path d='M50 140 A50 50 0 0 1 150 140' fill='none' stroke='#1FBF7A' stroke-width='14'/>
  <path d='M65 140 A35 35 0 0 1 135 140' fill='none' stroke='#63C7FF' stroke-width='14'/>
  <path d='M80 140 A20 20 0 0 1 120 140' fill='none' stroke='#FF3EA5' stroke-width='14'/>
  <ellipse cx='40' cy='148' rx='22' ry='10' fill='white'/>
  <ellipse cx='160' cy='148' rx='22' ry='10' fill='white'/>
</svg>`);

const rocket = () => svgDataUrl(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
  <rect width='200' height='200' fill='#D9F2FF' rx='28'/>
  <path d='M100 30 Q140 70 140 120 L140 150 L60 150 L60 120 Q60 70 100 30 Z' fill='white' stroke='#1B1B1F' stroke-width='5'/>
  <circle cx='100' cy='90' r='14' fill='#63C7FF' stroke='#1B1B1F' stroke-width='4'/>
  <path d='M60 130 L40 160 L70 150 Z' fill='#FF3EA5' stroke='#1B1B1F' stroke-width='4'/>
  <path d='M140 130 L160 160 L130 150 Z' fill='#FF3EA5' stroke='#1B1B1F' stroke-width='4'/>
  <path d='M85 160 Q100 180 115 160' fill='#FFB020' stroke='#1B1B1F' stroke-width='4'/>
</svg>`);

const confetti = () => svgDataUrl(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
  <rect width='200' height='200' fill='white' rx='28'/>
  <g>
    <circle cx='40' cy='40' r='8' fill='#FF3EA5'/>
    <circle cx='160' cy='50' r='6' fill='#63C7FF'/>
    <circle cx='60' cy='160' r='7' fill='#FFB020'/>
    <circle cx='150' cy='150' r='9' fill='#1FBF7A'/>
    <rect x='100' y='30' width='12' height='6' fill='#FF3EA5' transform='rotate(20 106 33)'/>
    <rect x='30' y='100' width='12' height='6' fill='#63C7FF' transform='rotate(-25 36 103)'/>
    <rect x='160' y='100' width='12' height='6' fill='#1FBF7A' transform='rotate(40 166 103)'/>
    <rect x='90' y='150' width='12' height='6' fill='#FFB020' transform='rotate(-15 96 153)'/>
  </g>
  <text x='100' y='115' text-anchor='middle' font-family='Fredoka, sans-serif' font-weight='700' font-size='28' fill='#1B1B1F'>YAY!</text>
</svg>`);

const flower = () => svgDataUrl(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
  <rect width='200' height='200' fill='white' rx='28'/>
  <g stroke='#1B1B1F' stroke-width='5'>
    <circle cx='100' cy='60' r='22' fill='#FF3EA5'/>
    <circle cx='60' cy='100' r='22' fill='#FF3EA5'/>
    <circle cx='140' cy='100' r='22' fill='#FF3EA5'/>
    <circle cx='100' cy='140' r='22' fill='#FF3EA5'/>
    <circle cx='100' cy='100' r='22' fill='#FFB020'/>
  </g>
</svg>`);

const crown = () => svgDataUrl(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
  <rect width='200' height='200' fill='white' rx='28'/>
  <path d='M30 140 L40 70 L75 110 L100 50 L125 110 L160 70 L170 140 Z' fill='#FFB020' stroke='#1B1B1F' stroke-width='5'/>
  <rect x='30' y='140' width='140' height='18' fill='#E61E86' stroke='#1B1B1F' stroke-width='5'/>
  <circle cx='100' cy='100' r='8' fill='#FF3EA5'/>
</svg>`);

export const PRESETS = [
  { id: 'star-yellow', label: 'Sunshine Star', url: star('#FFB020') },
  { id: 'star-pink', label: 'Pink Star', url: star('#FF3EA5') },
  { id: 'star-blue', label: 'Sky Star', url: star('#63C7FF') },
  { id: 'heart-pink', label: 'Pink Heart', url: heart('#FF3EA5') },
  { id: 'smiley', label: 'Happy Smiley', url: smiley() },
  { id: 'cake', label: 'Birthday Cake', url: cake() },
  { id: 'paw', label: 'Paw Print', url: paw() },
  { id: 'dino', label: 'Mini Dino', url: dino() },
  { id: 'rainbow', label: 'Rainbow', url: rainbow() },
  { id: 'rocket', label: 'Rocket', url: rocket() },
  { id: 'confetti', label: 'Confetti YAY', url: confetti() },
  { id: 'flower', label: 'Flower', url: flower() },
  { id: 'crown', label: 'Crown', url: crown() },
];

export const TEXT_COLORS = [
  { id: 'pink', label: 'Pink', value: '#FF3EA5' },
  { id: 'choco', label: 'Chocolate', value: '#4A2A1A' },
  { id: 'sky', label: 'Sky', value: '#63C7FF' },
  { id: 'gold', label: 'Gold', value: '#FFB020' },
  { id: 'ink', label: 'Ink', value: '#1B1B1F' },
  { id: 'green', label: 'Green', value: '#1FBF7A' },
];

export const BG_COLORS = [
  { id: 'cream', label: 'Cream', value: '#FFF6EC' },
  { id: 'sky', label: 'Sky', value: '#D9F2FF' },
  { id: 'pink', label: 'Pink', value: '#FFE0EF' },
  { id: 'yellow', label: 'Sunny', value: '#FFEFC9' },
  { id: 'white', label: 'White', value: '#FFFFFF' },
];
